export const getStatusType = (status: string): 'success' | 'in-progress' | 'error' | 'info' | 'warning' => {
  if (!status || status === 'UNKNOWN') return 'info';
  if (status === 'ACTIVE') return 'success';
  if (status === 'ARCHIVED') return 'info';
  if (['CREATING', 'UPDATING', 'DELETING'].includes(status)) return 'in-progress';
  if (status === 'DELETED') return 'error';
  return 'warning';
};
